export const MAX_RELEASE_DATE_ISO = "9999-12-31T23:59:59.9999999";

export type ProjectItem2 = { id: number; name: string };

export type SharedEmployee2 = {
  employeeId: number;
  companyId: number;
  name: string;
  surname: string;
  position: string;
  managerId: number;
  managerCompanyId: number;
  temporaryManagerId: number | null;
  temporaryManagerCompanyId: number | null;
  temporaryManagerFullName: string | null;
  startDateOfTheRental: string | null;
  endDateOfTheRental: string | null;
  releaseStartDate: string | null;
  releaseEndDate: string | null;
  canManage: boolean;
};

export type AvailableEmployee2 = {
  employeeId: number;
  companyId: number;
  companyName: string;
  name: string;
  surname: string;
  position: string;
  absence: boolean;
  releaseStartDate: string;
  releaseEndDate: string;
  managerId: number;
  managerCompanyId: number;
  projects: ProjectItem2[];
};

export type HistoryEmployee2 = {
  companyId: number;
  employeeId: number;
  firstName: string;
  lastName: string;
  position: string;
  companyName: string;
  count: number;
  lastAction: string;
};

export type HistoryEntry2 = {
  id: number;
  actionType: string;
  actionDate: string;
  startDateOfTheRental: string;
  endDateOfTheRental: string;
  managerId: number;
  managerCompanyId: number;
  managerFullName: string;
  temporaryManagerId: number | null;
  temporaryManagerCompanyId: number | null;
  temporaryManagerFullName: string | null;
  actionByUserId: number | null;
};

export const isIndefiniteDate = (value: string | Date | null | undefined): boolean => {
  if (!value) return false;
  if (typeof value === "string") {
    if (value === MAX_RELEASE_DATE_ISO) return true;
    return new Date(value).getFullYear() === 9999;
  }
  return value.getFullYear() === 9999;
};

export const formatDateOrIndefinite = (
  value: string | Date | null | undefined,
  indefiniteLabel: string,
): string => {
  if (!value) return "—";
  if (isIndefiniteDate(value)) return indefiniteLabel;
  const d = typeof value === "string" ? new Date(value) : value;
  return d.toLocaleString(undefined, { hour12: false });
};

export const companyNameById = (id: number): string => {
  switch (id) {
    case 1:
      return "Invenio";
    case 2:
      return "Invenio QD";
    case 3:
      return "Quality & Human Services";
    case 4:
      return "IPSUPPORT";
    default:
      return "";
  }
};
